var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkling2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.6516 3.42325C4.97758 2.74893 4.51625 1.5714 4.2873 0.5C4.058 1.57162 3.59715 2.7494 2.92289 3.42371C2.24888 4.09756 1.07109 4.55894 0 4.78837C1.07153 5.01733 2.2491 5.47844 2.92311 6.15278C3.59713 6.82685 4.05846 8.00463 4.28777 9.07603C4.51671 8.00441 4.97791 6.82663 5.65182 6.15232C6.32583 5.47825 7.50362 5.01709 8.57471 4.78766C7.50342 4.55869 6.32586 4.09735 5.6516 3.42325Z",
    fill: "url(#paint0_linear_6486_128663)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0299 8.82257C9.62756 8.42002 9.35151 7.71617 9.21473 7.07617C9.07772 7.71617 8.80259 8.41999 8.39982 8.82279C7.99705 9.22516 7.2934 9.50099 6.65356 9.63802C7.29362 9.77502 7.99705 10.0504 8.39982 10.4532C8.80259 10.8558 9.07821 11.5596 9.2152 12.1996C9.35194 11.5594 9.62756 10.8558 10.0301 10.453C10.4326 10.0504 11.1364 9.77478 11.7761 9.63756C11.1364 9.50077 10.4327 9.22516 10.0299 8.82257Z",
    fill: "url(#paint1_linear_6486_128663)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88944 10.1982C2.77441 10.7355 2.54341 11.3266 2.20534 11.6647C1.86732 12.0025 1.27654 12.234 0.73938 12.3491C1.27654 12.4643 1.86732 12.6951 2.20534 13.0334C2.54341 13.3715 2.77487 13.9621 2.88991 14.4997C3.00483 13.9621 3.23594 13.3715 3.57412 13.0332C3.91192 12.6952 4.50281 12.4639 5.03986 12.3486C4.50284 12.2338 3.91192 12.0025 3.5739 11.6645C3.23594 11.3266 3.00437 10.7356 2.88944 10.1982Z",
    fill: "url(#paint2_linear_6486_128663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6486_128663",
    x1: 0,
    y1: 4.78801,
    x2: 8.57471,
    y2: 4.78801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54ACDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A954DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6486_128663",
    x1: 6.65356,
    y1: 9.6379,
    x2: 11.7761,
    y2: 9.6379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54ACDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A954DE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6486_128663",
    x1: 0.73938,
    y1: 12.3489,
    x2: 5.03986,
    y2: 12.3489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54ACDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A954DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkling2);
export default __webpack_public_path__ + "static/media/sparkling_2.5d1e4203980a3de91b8517476ea2c467.svg";
export { ForwardRef as ReactComponent };